/**
 * Shared operational constants for transit-path map overlays (itinerary + realtime).
 */

/**
 * Screen-space collision priority tiers for transit-path stop label HTML markers.
 * Higher values win placement when labels overlap during pan/zoom.
 */
export const TRANSIT_PATH_STOP_LABEL_COLLISION_PRIORITY = {

    /** Traversed stops on the realtime vehicle path overlay. */
    "realtimePast": 25,

    /** Intermediate stops on itinerary legs and future realtime segments. */
    "intermediate": 50,

    /** Itinerary endpoints and highlighted realtime stops. */
    "highlight": 100,

    /** Next remaining stop on a realtime vehicle path (filled route-color chip). */
    "realtimeNextStop": 100,

    /** Final remaining stop on a realtime vehicle path (outline terminus chip). */
    "realtimeTerminus": 100,
} as const;
